import {Injectable} from '@angular/core';

@Injectable()
export class AppConstants {
  static SYSTEM_ENTRY_START_YEAR = 2019;
  static RE_REGISTRATION_ENTRY_START_YEAR = 2014;

  static INSTITUTION_TYPES = [
    { value: 'UNIVERSITY', option: 'University' },
    { value: 'COLLEGE', option: 'College' },
    { value: 'INSTITUTE', option: 'Institute' },
    { value: 'OTHER', option: 'Other' }
  ];

  static bloodGroups: any = [
    {
      name: 'A+',
      value: 'A+'
    },
    {
      name: 'A-',
      value: 'A-'
    },
    {
      name: 'B+',
      value: 'B+'
    },
    {
      name: 'B-',
      value: 'B-'
    },
    {
      name: 'AB+',
      value: 'AB+'
    },
    {
      name: 'AB-',
      value: 'AB-'
    },
    {
      name: 'O+',
      value: 'O+'
    },
    {
      name: 'O-',
      value: 'O-'
    }
  ];

  static OFFICE_TYPES = [
    { value: 'DESKTOP', option: 'DESKTOP' },
    { value: 'LAPTOP', option: 'LAPTOP' },
    { value: 'PHONE', option: 'PHONE' },
    { value: 'ACCESSORIES', option: 'ACCESSORIES' },
    { value: 'OTHER', option: 'OTHER' }
  ];

  static DEFAULT_COUNTRY = {
    id: '100',
    name: 'India'
  };

  static FIXED_STAGE_IDS = [1, 2, 3, 4, 5];
  static ADMISSION_DONE_STAGE_ID = 5;
  static FIXED_REASON_IDS = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
    22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40
  ];
  static FIXED_SR_MAPPING_IDS = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
    22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40
  ];

  static categories = [
    {
      name: 'General',
      value: 'GENERAL'
    },
    {
      name: 'OBC',
      value: 'OBC'
    },
    {
      name: 'SC',
      value: 'SC'
    },
    {
      name: 'ST',
      value: 'ST'
    },
    {
      name: 'Others',
      value: 'OTHERS'
    }
  ];

  static processStatusesCounselorForListStudents = [
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Processable',
      value: 'PROCESSABLE'
    },
    {
      name: 'Processed',
      value: 'PROCESSED_BY_COUNSELOR'
    },
    {
      name: 'Processed By Head Counselor',
      value: 'PROCESSED_BY_HEAD_COUNSELOR'
    },
    {
      name: 'Verified',
      value: 'VERIFIED'
    },
    {
      name: 'Document Required',
      value: 'DOCUMENT_REQUIRED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static processStatusesHeadCounselorForListStudents: any = [
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Processable',
      value: 'PROCESSABLE'
    },
    {
      name: 'Processed',
      value: 'PROCESSED_BY_HEAD_COUNSELOR'
    },
    {
      name: 'Verified',
      value: 'VERIFIED'
    },
    {
      name: 'Document Required',
      value: 'DOCUMENT_REQUIRED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static processStatusesCounselorForProcessStudents: any = [
    {
      name: 'Processable',
      value: 'PROCESSABLE'
    },
    {
      name: 'Processed',
      value: 'PROCESSED_BY_COUNSELOR'
    },
    {
      name: 'Processed By Head Counselor',
      value: 'PROCESSED_BY_HEAD_COUNSELOR'
    },
    {
      name: 'Verified',
      value: 'VERIFIED'
    }
  ];

  static processStatusesHeadCounselorForProcessStudents: any = [
    {
      name: 'Processable',
      value: 'PROCESSABLE'
    },
    {
      name: 'Processed',
      value: 'PROCESSED_BY_HEAD_COUNSELOR'
    },
    {
      name: 'Verified',
      value: 'VERIFIED'
    }
  ];

  static processStatusesHeadCounselorCounselorStudentForProcessStudents: any = [
    {
      name: 'Processable',
      value: 'PROCESSED_BY_COUNSELOR'
    },
    {
      name: 'Processed',
      value: 'PROCESSED_BY_HEAD_COUNSELOR'
    },
    {
      name: 'Verified',
      value: 'VERIFIED'
    }
  ];

  static processStatusesAdminForProcessStudents: any = [
    {
      name: 'Not Verified',
      value: 'PROCESSED_BY_HEAD_COUNSELOR'
    },
    {
      name: 'Verified',
      value: 'VERIFIED'
    },
    {
      name: 'Document Required',
      value: 'DOCUMENT_REQUIRED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static processTypes = [
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Processable',
      value: 'PROCESSABLE'
    },
    {
      name: 'Processed By Head Counselor',
      value: 'PROCESSED_BY_HEAD_COUNSELOR'
    },
    {
      name: 'Processed By Counselor',
      value: 'PROCESSED_BY_COUNSELOR'
    },
    {
      name: 'Verified',
      value: 'VERIFIED'
    },
    {
      name: 'Document Required',
      value: 'DOCUMENT_REQUIRED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static employementStatuses = [
    {
      name: 'Employed',
      value: 'EMPLOYED'
    },
    {
      name: 'Un-Employed',
      value: 'UN_EMPLOYED'
    }
  ];

  static verificationStatues: any = [
    {
      name: 'Verified',
      value: 'VERIFIED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    },
    {
      name: 'Document Required',
      value: 'DOCUMENT_REQUIRED'
    }
  ];

  static filterVerficationStatuses: any = [
    {
      name: 'Verified',
      value: 'VERIFIED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    },
    {
      name: 'Document Required',
      value: 'DOCUMENT_REQUIRED'
    }
  ];

  static filterProcessTypes: any = [
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Processable',
      value: 'PROCESSABLE'
    },
    {
      name: 'Processing',
      value: 'PROCESSING_BY_CENTER'
    },
    {
      name: 'Processed',
      value: 'PROCESSED'
    }
  ];

  static universityVerificationStatues: any = [
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Verified',
      value: 'VERIFIED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static universityVerificationStatuesFilter: any = [
    {
      name: 'Verified',
      value: 'VERIFIED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static supportTicketStatuses: any = [
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Resolved',
      value: 'RESOLVED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static allticketsTypes: any = [
    {
      name: 'Admission Ticket',
      value: 'ADMISSION_TICKET'
    },
    {
      name: 'Re-Registration Ticket',
      value: 'RE_REGISTRATION_TICKET'
    },
    {
      name: 'Examination Ticket',
      value: 'EXAMINATION_TICKET'
    },
    {
      name: 'Marksheet Ticket',
      value: 'MARKSHEET_TICKET'
    },
    {
      name: 'Transcript Ticket',
      value: 'TRANSCRIPT_TICKET'
    },
    {
      name: 'Revaluation Ticket',
      value: 'REVALUATION_TICKET'
    },
    {
      name: 'Migration Ticket',
      value: 'MIGRATION_TICKET'
    },
    {
      name: 'Original Degree Ticket',
      value: 'ORIGINAL_DEGREE_TICKET'
    },
    {
      name: 'E-Learning Ticket',
      value: 'E_LEARNING_TICKET'
    },
    {
      name: 'Other Ticket',
      value: 'OTHER_TICKET'
    }
  ];
  static issueStatuses: any = [
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Payment Received',
      value: 'PAYMENT_RECEIVED'
    },
    {
      name: 'Out For Delivery',
      value: 'OUT_FOR_DELIVERY'
    },
    {
      name: 'Delivered',
      value: 'DELIVERED'
    },
    {
      name: 'Payment Not Required',
      value: 'PAYMENT_NOT_REQUIRED'
    }
  ];

  static issuePaymentStatuses: any = [
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Success',
      value: 'SUCCESS'
    },
    {
      name: 'Failed',
      value: 'FAILED'
    }
  ];

  static receiptStatus: any = [
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Accepted',
      value: 'ACCEPTED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static admissionTypes: any = [
    {
      name: 'Fresh Admission',
      value: 'FRESH_ADMISSION',
      default_semester: 1
    },
    {
      name: 'Lateral Entry',
      value: 'LATERAL_ENTRY',
      default_semester: 3
    },
    {
      name: 'Credit Transfer',
      value: 'CREDIT_TRANSFER',
      default_semester: 5
    }
  ];

  static months: any = [
    {
      name: 'January',
      value: 1
    },
    {
      name: 'February',
      value: 2
    },
    {
      name: 'March',
      value: 3
    },
    {
      name: 'April',
      value: 4
    },
    {
      name: 'May',
      value: 5
    },
    {
      name: 'June',
      value: 6
    },
    {
      name: 'July',
      value: 7
    },
    {
      name: 'August',
      value: 8
    },
    {
      name: 'September',
      value: 9
    },
    {
      name: 'October',
      value: 10
    },
    {
      name: 'November',
      value: 11
    },
    {
      name: 'December',
      value: 12
    }
  ];

  static years: any = [
    {
      name: '2026',
      value: '2026'
    },
    {
      name: '2025',
      value: '2025'
    },

    {
      name: '2024',
      value: '2024'
    },
    {
      name: '2023',
      value: '2023'
    }
  ];

  static unRemovedYears: any = [1, 2, 3];

  static removedYears: any = [2, 3];

  static sessionTypes: any = [
    {
      name: 'Calendar',
      value: 'CAL'
    },
    {
      name: 'Academic',
      value: 'ACD'
    }
  ];

  static subjectTypes: any = [
    {
      name: 'Theory',
      value: 'THEORY'
    },
    {
      name: 'Practical',
      value: 'PRACTICAL'
    }
  ];

  static transferredStudentStatuses: any = [
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Transferred',
      value: 'TRANSFERRED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static filterBackMarkStatusForUniversity: any = [
    {
      name: 'Marked',
      value: 'MARKED_BY_CENTER'
    },
    {
      name: 'Rejected',
      value: 'REJECTED_BY_UNIVERSITY'
    }
  ];

  static attendance_years: any = [
    {
      name: '2026',
      value: '2026'
    },
    {
      name: '2025',
      value: '2025'
    },
    {
      name: '2024',
      value: '2024'
    }
  ];

  static semester_nos = [1, 2, 3, 4, 5, 6, 7, 8];

  static maritalStatues: any = [
    {
      name: 'SINGLE',
      value: 'SINGLE'
    },
    {
      name: 'MARRIED',
      value: 'MARRIED'
    },
    {
      name: 'DIVORCED',
      value: 'DIVORCED'
    },
    {
      name: 'WIDOWED',
      value: 'WIDOWED'
    },
    {
      name: 'SEPARATED',
      value: 'SEPARATED'
    }
  ];

  static designation_statues: any = [
    {
      name: 'Normal',
      value: 'NORMAL'
    },
    {
      name: 'HOD',
      value: 'HOD'
    },
    {
      name: 'Registrar',
      value: 'REGISTRAR'
    },
    {
      name: 'HR',
      value: 'HR'
    },
    {
      name: 'Accountant',
      value: 'ACCOUNTANT'
    },
    {
      name: 'PRO VC',
      value: 'PRO_VC'
    },
    {
      name: 'Chief Hostel Warden',
      value: 'CHIEF_HOSTEL_WARDEN'
    },
    {
      name: 'Dean',
      value: 'DEAN'
    },
    {
      name: 'Vice Principal',
      value: 'VICE_PRINCIPAL'
    },
    {
      name: 'Principal',
      value: 'PRINCIPAL'
    },
    {
      name: 'Dean Academic Affair',
      value: 'DEAN_Academic_Affair'
    },
    {
      name: 'Campus Officer',
      value: 'CAMPUS_OFFICER'
    },
    {
      name: 'Supervisor',
      value: 'SUPERVISOR'
    },
    {
      name: 'Senior Supervisor',
      value: 'SENIOR_SUPERVISOR'
    },
    {
      name: 'VC',
      value: 'VC'
    }
  ];

  static genders: any = [
    {
      name: 'Male',
      value: 'MALE'
    },
    {
      name: 'Female',
      value: 'FEMALE'
    },
    {
      name: 'Others',
      value: 'OTHER'
    }
  ];

  static maritalStatus: any = [
    {
      name: 'Single',
      value: 'SINGLE'
    },
    {
      name: 'Married',
      value: 'MARRIED'
    }
  ];

  static category: any = [
    {
      name: 'Fresh Admission',
      value: 'FRESH_ADMISSION'
    },
    {
      name: 'Lateral Entry',
      value: 'LATERAL_ENTRY'
    },
    {
      name: 'Credit Transfer',
      value: 'CREDIT_TRANSFER'
    }
  ];

  static divisions: any = [
    {
      name: 'First',
      value: 1
    },
    {
      name: 'Second',
      value: 2
    },
    {
      name: 'Third',
      value: 3
    }
  ];

  static religions: any = [
    {
      name: 'Hindu',
      value: 'HINDU'
    },
    {
      name: 'Muslim',
      value: 'MUSLIM'
    },
    {
      name: 'Christian',
      value: 'CHRISTIAN'
    },
    {
      name: 'Jain',
      value: 'JAIN'
    },
    {
      name: 'Buddhist',
      value: 'BUDDHIST'
    },
    {
      name: 'Sikh',
      value: 'SIKH'
    },
    {
      name: 'Others',
      value: 'OTHERS'
    }
  ];

  static nationalities: any = [
    {
      name: 'Indian',
      value: 'INDIAN'
    },
    {
      name: 'Others',
      value: 'OTHERS'
    }
  ];

  static transactionTypes: any = [
    {
      name: 'NEFT',
      value: 'NEFT'
    },
    {
      name: 'DD',
      value: 'DD'
    },
    {
      name: 'IMPS',
      value: 'IMPS'
    },
    {
      name: 'UPI',
      value: 'UPI'
    },
    {
      name: 'Cheque Deposit',
      value: 'CHEQUE'
    },
    {
      name: 'Bank Cash Deposit',
      value: 'BANK_CASH_DEPOSIT'
    },
    {
      name: 'Cash',
      value: 'CASH'
    },
    {
      name: 'Other',
      value: 'OTHER'
    }
  ];

  static banks: any = [
    {
      name: 'Axis Bank',
      value: 'AXIS'
    },
    {
      name: 'ICICI Bank',
      value: 'ICICI'
    },
    {
      name: 'State Bank of India (SBI)',
      value: 'SBI'
    },
    {
      name: 'Central Bank of India (CBI)',
      value: 'CBI'
    },
    {
      name: 'HDFC Bank',
      value: 'HDFC'
    },
    {
      name: 'IDFC Bank',
      value: 'IDFC'
    },
    {
      name: 'Punjab National Bank (PNB)',
      value: 'PNB'
    },
    {
      name: 'Canara Bank',
      value: 'CANARA'
    },
    {
      name: 'Other Bank',
      value: 'OTHER'
    }
  ];

  static receiptStatuses: any = [
    {
      name: 'Pending',
      value: 'PENDING'
    },
    {
      name: 'Accepted',
      value: 'ACCEPTED'
    },
    {
      name: 'Rejected',
      value: 'REJECTED'
    }
  ];

  static employeeShiftStatus: any = [
    {
      name: 'Day Shift',
      value: 'DAY_SHIFT'
    },
    {
      name: 'Night Shift',
      value: 'NIGHT_SHIFT'
    }
  ];

  static attendanceTypes: any = [
    {
      name: 'Present',
      value: 'P'
    },
    {
      name: 'On Duty',
      value: 'OD'
    },
    {
      name: 'Weekly Off',
      value: 'S'
    },
    {
      name: 'Holiday',
      value: 'H'
    },
    {
      name: 'Restricted Holiday',
      value: 'RH'
    },
    {
      name: 'Casual Leave',
      value: 'CL'
    },
    {
      name: 'Paid Leave',
      value: 'PL'
    },
    {
      name: 'Medical Leave',
      value: 'ML'
    },
    {
      name: 'Compensatory Off',
      value: 'CO'
    },
    {
      name: 'Absent',
      value: 'A'
    },
    {
      name: 'Leave Without Pay',
      value: 'LWP'
    }
  ];
}
